import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";
import { combineEpics } from "redux-observable";
import {
  REQUEST_CLIENTS,
  requestClientsStarted,
  setClients,
  setClientsError,
  SUBMIT_CREATE_CLIENT_ADMIN,
} from "./AdminPage.state";
import { getClients } from "@/APIClient";
import { getAuthToken } from "@/util/session";
import { requestEpic } from "@/APIClient/observable.util";
import { createAdministeredUser } from "@/components/administeredUsers/AdministeredUsers.state";
import { resetSettingsPageWorkflow } from "@/components/userSettingsPage/UserSettingsPage.state";
import { DEFAULT_TIMEZONE } from "@/util/dates";
import { CREATE_CLIENT_ADMIN } from "@/constants/formTypes";

const requestClientsEpic = (action$) =>
  action$.pipe(
    ofType(REQUEST_CLIENTS),
    RxOp.mergeMap(() =>
      Rx.concat([
        Rx.of(requestClientsStarted()),
        requestEpic({
          requestMethod: getClients,
          requestArgs: {
            token: S.fromMaybe("")(getAuthToken()),
          },
          onSuccess: (res) =>
            Rx.of(setClients(S.fromEither({})(res)), resetSettingsPageWorkflow()),
          onFailure: (err) => Rx.of(setClientsError({ error: err })),
        }),
      ])
    ),
    RxOp.concatAll(),
    RxOp.catchError((err) => Rx.of(setClientsError({ error: err.message })))
  );

const buildCreateClientAdminPayload = (state) => {
  const client =
    state?.adminPage?.clients?.value?.find(
      (client) =>
        client?.brand ===
        state?.adminPage?.forms?.createClientAdminForm?.client?.rawValue
    ) ?? "";

  return {
    client: client.slug,
    firstName: state.adminPage.forms.createClientAdminForm.firstName.rawValue,
    lastName: state.adminPage.forms.createClientAdminForm.lastName.rawValue,
    email: state.adminPage.forms.createClientAdminForm.email.rawValue,
    role: state.adminPage.forms.createClientAdminForm.role.rawValue,
    timezone: DEFAULT_TIMEZONE,
    agencies: [],
    formType: CREATE_CLIENT_ADMIN,
  };
};

export const createClientAdminEpic = (action$, state$) =>
  action$.pipe(
    ofType(SUBMIT_CREATE_CLIENT_ADMIN),
    RxOp.flatMap(() =>
      Rx.of(createAdministeredUser(buildCreateClientAdminPayload(state$.value)))
    )
  );

export default combineEpics(requestClientsEpic, createClientAdminEpic);
